const PLP_ASSET = p => window.PLP_BASE ? window.PLP_BASE + "plpm-" + p.replace(/\//g, "-").replace(/\.(jpg|png)$/, ".webp") : "assets/web/" + p;
const PLP_VIDEO = p => (window.PLP_VIDEOS ? window.PLP_VIDEOS[p] || "" : "assets/video/" + p);
/* page options */
// Men's page options (read by app.js, gallery.js, buybox.js, picker.js)
window.POLAR_DEFAULTS = { shade: "black", bundle: 0 }; // preselect Black + 1 bottle
window.POLAR_PAGE = {
  shades: ["black", "dark-brown", "medium-brown", "light-brown", "blonde"], // no Red / Purple
  etaFlag: true,   // delivery line in the picker shows the visitor's country flag
  prefillPicker: true, // picker opens with the buy-box shade + quantity already added
  boxDyeUsd: 10,   // box dye price used in comparisons (USD, converted per market)
  // Every image path is written out in full (the Shopify build finds and converts them)
  // Shade picker "Hair tone": short men's hair close-ups
  toneImg: key => ({ "black": PLP_ASSET("m/tones/black.jpg"), "dark-brown": PLP_ASSET("m/tones/dark-brown.jpg"), "medium-brown": PLP_ASSET("m/tones/medium-brown.jpg"), "light-brown": PLP_ASSET("m/tones/light-brown.jpg"), "blonde": PLP_ASSET("m/tones/blonde.jpg") })[key],
  // Square before/afters per shade (shade finder + picker)
  shadeImg: key => ({ "black": PLP_ASSET("m/ba/ba-10.jpg"), "dark-brown": PLP_ASSET("m/ba/ba-dark-brown.jpg"), "medium-brown": PLP_ASSET("m/ba/ba-8.jpg"), "light-brown": PLP_ASSET("m/ba/ba-light-brown.jpg"), "blonde": PLP_ASSET("m/ba/ba-blonde.jpg") })[key],
  // Buy-box gallery (4:3): bottle + box shot, then the shade's before/after
  galleryBottleImg: key => ({ "black": PLP_ASSET("m/g/bottle-black-g.jpg"), "dark-brown": PLP_ASSET("m/g/bottle-dark-brown-g.jpg"), "medium-brown": PLP_ASSET("m/g/bottle-medium-brown-g.jpg"), "light-brown": PLP_ASSET("m/g/bottle-light-brown-g.jpg"), "blonde": PLP_ASSET("m/g/bottle-blonde-g.jpg") })[key],
  galleryShadeImg: key => ({ "black": PLP_ASSET("m/g/ba-10-g.jpg"), "dark-brown": PLP_ASSET("m/g/ba-dark-brown-g.jpg"), "medium-brown": PLP_ASSET("m/g/ba-8-g.jpg"), "light-brown": PLP_ASSET("m/g/ba-light-brown-g.jpg"), "blonde": PLP_ASSET("m/g/ba-blonde-g.jpg") })[key],
  gallery: [
    { src: PLP_ASSET("m/g/ba-1-g.jpg"), alt: "Man before and after: gray hair and beard colored dark brown" },
    { src: PLP_ASSET("m/g/ba-7-g.jpg"), alt: "Man before and after: full gray beard colored brown" },
  ],
  finderNotes: {
    match: "The closest match to your own color, so the gray blends in. No flat look.",
    darker: "With more gray, one shade darker blends better and avoids a warm, reddish tint.",
    dark: "Deep color that looks like your own, even at the temples and in the beard.",
    blonde: "Blonde softens the gray for a light, low-key look.",
  },
  // "Real guys. Real results." video carousel (men's testimonials supplied by Polar, 2026-10-01)
  tvids: [
    { src: PLP_VIDEO("m/tvm-1.mp4"), poster: PLP_ASSET("m/tv/tvm-1.jpg") },
    { src: PLP_VIDEO("m/tvm-2.mp4"), poster: PLP_ASSET("m/tv/tvm-2.jpg") },
    { src: PLP_VIDEO("m/tvm-3.mp4"), poster: PLP_ASSET("m/tv/tvm-3.jpg") },
    { src: PLP_VIDEO("m/tvm-4.mp4"), poster: PLP_ASSET("m/tv/tvm-4.jpg") },
    { src: PLP_VIDEO("m/tvm-5.mp4"), poster: PLP_ASSET("m/tv/tvm-5.jpg") },
    { src: PLP_VIDEO("m/tv-NG5olgw5C.mp4"), poster: PLP_ASSET("m/tv/NG5olgw5C.jpg") },
    { src: PLP_VIDEO("m/tv-Hm99lXSpb.mp4"), poster: PLP_ASSET("m/tv/Hm99lXSpb.jpg") },
  ],
};

// Leave out testimonial videos that have no uploaded link yet
window.POLAR_PAGE.tvids = window.POLAR_PAGE.tvids.filter(v => v.src);

/* app.js */
// ---- Settings -------------------------------------------------------------
// Set the real Early Black Friday Sale end (ISO time with timezone) to show the countdown,
// e.g. "2026-10-15T23:59:00-04:00". A real SALE_ENDS always wins over the test timer below.
const SALE_ENDS = null;
// TESTING ONLY: countdown length in seconds that restarts from the top when it reaches zero.
// >>> Set to null (and set SALE_ENDS) before sending real traffic, including the A/B test. <<<
const TEST_TIMER_SECONDS = 8 * 3600 + 41 * 60 + 30; // 8:41:30
// Real share of the Early Black Friday Sale stock already sold (0-100). Shown in Variation B's
// "Selling out fast" box, together with SALE_ENDS. Leave null to hide that box.
const STOCK_SOLD_PCT = 87; // supplied by Polar 2026-09-30

const STORE = window.PLP_BASE ? "" : "https://polarhaircare.com"; // same domain on Shopify
const CONDITIONER_ID = 54600721826137; // Color Protect Conditioner (free gift with 3 bottles)

// Shopify variant IDs (US market), verified 2026-09-30 from /products/instant-dye-shampoo.js
// Pack Size: Standard = 1 bottle, Better = 2, Best = 3 (priced per bottle).
const ALL_SHADES = [
  { key: "black",        name: "Black",        hex: "#161515", ids: [57147715060057, 57147726922073, 57147726954841] },
  { key: "dark-brown",   name: "Dark Brown",   hex: "#3a281e", ids: [57147715092825, 57147726987609, 57147727020377] },
  { key: "medium-brown", name: "Medium Brown", hex: "#5b3b27", ids: [57147715125593, 57147727053145, 57147727085913] },
  { key: "light-brown",  name: "Light Brown",  hex: "#8b6547", ids: [57147715158361, 57147727118681, 57147727151449] },
  { key: "blonde",       name: "Blonde",       hex: "#c8a56d", ids: [57147715191129, 57147727184217, 57147727216985] },
  { key: "purple",       name: "Purple",       hex: "#4a2a6a", ids: [57147715223897, 57147727249753, 57147727282521] },
  { key: "red",          name: "Red",          hex: "#7b1e2a", ids: [57147715256665, 57147727315289, 57147727348057] },
];

// Page options: the men's page sets window.POLAR_PAGE (shade list, its own before/after photos,
// finder notes, gallery photos, testimonial videos). Without it, everything works as before.
const PAGE = window.POLAR_PAGE || {};
const SHADES = PAGE.shades ? ALL_SHADES.filter(s => PAGE.shades.includes(s.key)) : ALL_SHADES;
const shadeImg = PAGE.shadeImg || (key => PLP_ASSET(`shade-${key}.jpg`));

// ---- Pricing ------------------------------------------------------------------
// On Shopify, the layout sets window.PLP_PRICING from Liquid with the visitor's market prices
// (same currency and amounts as the product page and checkout). Locally we fall back to the
// supplied USD offer.
const PLP_PRICING = window.PLP_PRICING || null;
const CURRENCY = (PLP_PRICING && PLP_PRICING.currency) || "USD";
const LOCALE = { USD: "en-US", GBP: "en-GB", AUD: "en-AU", CAD: "en-CA", NZD: "en-NZ", EUR: "en-IE" }[CURRENCY] || "en-US";
const fmtMoney = new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY });
const fmtWhole = new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY, maximumFractionDigits: 0, minimumFractionDigits: 0 });

// Offer as supplied by Polar ("Up to 53% OFF + Free Gifts")
const BUNDLES = [
  { qty: 1, name: "1 Bottle",  price: 34.95, compare: 49.95,  save: "Save 30%", perks: "+ $4.95 shipping" },
  { qty: 2, name: "2 Bottles", price: 59.94, compare: 99.90,  save: "Save 40%", perks: "<b>Free shipping</b>" },
  { qty: 3, name: "3 Bottles", price: 70.95, compare: 149.85, save: "Save 53%", perks: "<b>Free shipping</b> + free gift", gift: true, tag: "BEST VALUE" },
];

// Page can override the preselected shade/bundle with window.POLAR_DEFAULTS (Variation B does)
// Replace the USD offer with the market's real Shopify prices when available
if (PLP_PRICING && PLP_PRICING.std) {
  const P = PLP_PRICING, per = [P.std, P.better, P.best];
  BUNDLES.forEach((o, i) => {
    o.price = Math.round(per[i] * o.qty * 100) / 100;
    if (P.compare) o.compare = Math.round(P.compare * o.qty * 100) / 100;
    o.save = `Save ${Math.round((1 - o.price / o.compare) * 100)}%`;
  });
}
// Shipping on 1 bottle and gift value, in the visitor's currency (null = not known for this market)
const SHIP_1 = PLP_PRICING ? PLP_PRICING.ship : 4.95;
const GIFT_VALUE = (PLP_PRICING && PLP_PRICING.gift) || 22.95;
BUNDLES[0].perks = SHIP_1 == null ? "+ shipping" : `+ ${fmtMoney.format(SHIP_1)} shipping`;
// Market price relative to the US price: used only for rough outside references (salon, box dye)
const MARKET_RATE = PLP_PRICING && PLP_PRICING.std ? PLP_PRICING.std / 34.95 : 1;
const USES_PER_BOTTLE = 15;
const perUse = i => BUNDLES[i].price / BUNDLES[i].qty / USES_PER_BOTTLE;
const approx = usd => fmtWhole.format(Math.round(usd * MARKET_RATE));
const MAX_SAVE = Math.max(...BUNDLES.map(o => Math.round((1 - o.price / o.compare) * 100)));

const state = Object.assign({ shade: "dark-brown", bundle: 2 }, window.POLAR_DEFAULTS || {});
const $ = (s, el = document) => el.querySelector(s);
const money = n => fmtMoney.format(n);
const shadeBy = k => SHADES.find(s => s.key === k);

// ---- Purchase module --------------------------------------------------------
function renderShades() {
  const row = $("#shades");
  if (!row) return; // Variation B picks shades in the shade picker instead
  row.innerHTML = "";
  SHADES.forEach(s => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "swatch";
    b.style.background = s.hex;
    b.setAttribute("role", "radio");
    b.setAttribute("aria-label", s.name);
    b.setAttribute("aria-checked", String(s.key === state.shade));
    b.tabIndex = s.key === state.shade ? 0 : -1;
    b.addEventListener("click", () => setShade(s.key));
    row.appendChild(b);
  });
  radioKeys(row, i => setShade(SHADES[i].key, true));
}

function renderBundles() {
  const box = $("#bundles");
  if (!box) return; // Variation B renders its own quantity tiles (buybox.js)
  box.innerHTML = "";
  BUNDLES.forEach((o, i) => {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "bundle";
    b.setAttribute("role", "radio");
    b.setAttribute("aria-checked", String(i === state.bundle));
    b.tabIndex = i === state.bundle ? 0 : -1;
    b.innerHTML = `
      ${o.tag ? `<span class="bundle__tag">${o.tag}</span>` : ""}
      <span class="bundle__radio" aria-hidden="true"></span>
      <span class="bundle__name">${o.name}<span class="bundle__save">${o.save}</span></span>
      <span class="bundle__price"><strong>${money(o.price)}</strong><s>${money(o.compare)}</s></span>
      <span class="bundle__perks">${o.perks}</span>
      ${o.gift ? `<span class="gift"><img src="${PLP_ASSET(`conditioner.jpg`)}" alt="" width="44" height="44" loading="lazy">Free gift: Color Protect Conditioner (${money(GIFT_VALUE)} value)</span>` : ""}`;
    b.addEventListener("click", () => setBundle(i));
    box.appendChild(b);
  });
  radioKeys(box, i => setBundle(i, true));
}

// Arrow-key support for the custom radio groups
function radioKeys(group, select) {
  group.onkeydown = e => {
    const items = [...group.children];
    const i = items.indexOf(document.activeElement);
    if (i < 0) return;
    const next = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!next) return;
    e.preventDefault();
    select((i + next + items.length) % items.length);
  };
}

function setShade(key, focus) {
  state.shade = key;
  renderShades();
  updateShop();
  if (focus && $("#shades")) $("#shades .swatch[aria-checked='true']").focus();
}

function setBundle(i, focus) {
  state.bundle = i;
  renderBundles();
  updateShop();
  if (focus && $("#bundles")) $("#bundles .bundle[aria-checked='true']").focus();
}

// Shopify cart permalink: opens checkout with exactly these lines.
// (The theme's /cart page redirects to the homepage, so /cart/add is not usable.)
// The store's automatic discount makes the conditioner free with 3 bottles
// (verified 2026-09-30: 4 items, $70.95 total, $22.95 saved).
function cartUrl() {
  const s = shadeBy(state.shade);
  const o = BUNDLES[state.bundle];
  const lines = [`${s.ids[state.bundle]}:${o.qty}`];
  if (o.gift) lines.push(`${CONDITIONER_ID}:1`);
  const url = new URL(`${STORE}/cart/${lines.join(",")}`, location.origin);
  // Carry campaign parameters (utm_*, fbclid) through to the store
  new URLSearchParams(location.search).forEach((v, k) => {
    if (/^utm_|^fbclid$/.test(k)) url.searchParams.set(k, v);
  });
  return url.toString();
}

function updateShop() {
  const s = shadeBy(state.shade);
  const o = BUNDLES[state.bundle];
  if ($("#shade-label")) $("#shade-label").textContent = s.name;
  const img = $("#shop-img");
  if (img) {
    img.src = PLP_ASSET(`bottle-${s.key}.jpg`);
    img.alt = `Polar Instant Dye Shampoo, ${s.name}`;
  }
  const add = $("#add");
  if (add) {
    add.textContent = `Buy now · ${money(o.price)}`;
    add.href = cartUrl();
  }
  document.dispatchEvent(new CustomEvent("polar:change"));
}

// ---- Shade finder -----------------------------------------------------------
const finder = { natural: null, gray: null };
const DARKER = { "medium-brown": "dark-brown", "light-brown": "medium-brown" };

function pressed(group, btn) {
  group.querySelectorAll("button").forEach(b => b.setAttribute("aria-pressed", String(b === btn)));
}

function recommend() {
  if (!finder.natural) return null;
  if (finder.natural === "fun") return { key: "red", note: "Red gives rich, bold color over grays. Prefer purple? You can switch below." };
  if (!finder.gray) return null;
  let key = finder.natural;
  const N = PAGE.finderNotes || {};
  let note = N.match || "The closest match to your natural color.";
  if (finder.gray === "high" && DARKER[key]) {
    key = DARKER[key];
    note = N.darker || "With more gray, one shade darker gives fuller coverage and a truer, less warm result.";
  } else if (finder.gray === "high" && key === "blonde") {
    note = N.blonde || "Blonde blends softly over high gray for a natural, low-maintenance look.";
  } else if (key === "black" || key === "dark-brown") {
    note = N.dark || "Deep, even coverage, even on stubborn grays at the temples.";
  }
  return { key, note };
}

function updateFinder() {
  $("#q-gray-wrap").hidden = finder.natural === "fun";
  const r = recommend();
  const result = $("#finder-result");
  // Pages can keep the before/after photo hidden until both questions are answered (data-reveal)
  const media = $(".finder__media[data-reveal]");
  if (media) media.hidden = !r;
  if (!r) { result.hidden = true; return; }
  const s = shadeBy(r.key);
  $("#finder-shade").textContent = s.name;
  $("#finder-note").textContent = r.note;
  const img = $("#finder-img");
  img.src = shadeImg(s.key);
  img.alt = `Before and after using ${s.name}`;
  $("#finder-cap").textContent = `${s.name} · before and after`;
  $("#finder-cta").textContent = `Choose my ${s.name} bundle`;
  result.hidden = false;
  state.fromFinder = true;
  setShade(s.key);
}

$("#q-natural").addEventListener("click", e => {
  const b = e.target.closest("button"); if (!b) return;
  finder.natural = b.dataset.v; pressed($("#q-natural"), b); updateFinder();
});
$("#q-gray").addEventListener("click", e => {
  const b = e.target.closest("button"); if (!b) return;
  finder.gray = b.dataset.v; pressed($("#q-gray"), b); updateFinder();
});

// ---- Countdown (only with a real end date) ---------------------------------
// Milliseconds left on the sale countdown: real SALE_ENDS, else the looping test timer, else null
let testEnd = TEST_TIMER_SECONDS ? Date.now() + TEST_TIMER_SECONDS * 1000 : null;
function saleLeft() {
  if (SALE_ENDS) return new Date(SALE_ENDS).getTime() - Date.now();
  if (!testEnd) return null;
  while (testEnd - Date.now() <= 0) testEnd += TEST_TIMER_SECONDS * 1000; // restart from the top
  return testEnd - Date.now();
}

function startTimer() {
  if (saleLeft() == null) return;
  const el = $("#timer");
  const pad = n => String(n).padStart(2, "0");
  const tick = () => {
    const left = saleLeft();
    if (left <= 0) { el.textContent = "Sale ended"; clearInterval(t); return; }
    const h = Math.floor(left / 36e5), m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
    el.querySelector('[data-t="h"]').textContent = pad(h);
    el.querySelector('[data-t="m"]').textContent = pad(m);
    el.querySelector('[data-t="s"]').textContent = pad(s);
  };
  el.hidden = false; tick();
  const t = setInterval(tick, 1000);
}

// ---- Sticky CTA: visible after the hero, hidden over the purchase module ---
function sticky() {
  const bar = $("#sticky");
  const seen = new Map();
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => seen.set(e.target, e.isIntersecting));
    const heroVisible = seen.get($(".hero")) ?? true;
    const shopVisible = seen.get($("#shop")) || seen.get($(".site-footer"));
    bar.hidden = heroVisible || shopVisible;
  });
  [$(".hero"), $("#shop"), $(".site-footer")].forEach(el => io.observe(el));
}

// Shared with the Variation B shade picker (picker.js)
window.Polar = { state, SHADES, PAGE, shadeImg, BUNDLES, STORE, CONDITIONER_ID, money, shadeBy, setBundle, SALE_ENDS, saleLeft, STOCK_SOLD_PCT, SHIP_1, GIFT_VALUE, perUse, approx, MAX_SAVE, CURRENCY };

renderShades();
renderBundles();
updateShop();
startTimer();
sticky();

/* gallery.js */
// Variation B buy box: color explorer + per-shade product photo carousel.
// Exploring a color only changes the photos (and which card opens first in the shade picker);
// the shades that go to checkout are chosen in the picker.
(() => {
  const { state, SHADES, shadeBy, PAGE, shadeImg } = window.Polar;
  const $ = s => document.querySelector(s);
  const track = $("#gallery-track"), dots = $("#gallery-dots"), thumbs = $("#gallery-thumbs");
  let shown = null;

  // Same order as the product page: the shade's bottle first, then shared photos
  const photos = s => [
    { src: PAGE.galleryBottleImg ? PAGE.galleryBottleImg(s.key) : PLP_ASSET(`bottle-${s.key}.jpg`), alt: `Polar Instant Dye Shampoo, ${s.name}, 200 ml bottle and box` },
    { src: (PAGE.galleryShadeImg || shadeImg)(s.key), alt: s.key === "purple" ? "Result with Purple" : `Before and after with ${s.name}` },
    ...(PAGE.gallery || [
      { src: PLP_ASSET("pdp-Untitl.jpg"), alt: "Four customers before and 10 minutes after using Polar" },
      { src: PLP_ASSET("pdp-9_45b4.jpg"), alt: "Gray beard before and after using Polar" },
    ]),
  ];

  function renderExplore() {
    $("#explore").innerHTML = SHADES.map(s => `
      <button type="button" class="swatch-tile" role="radio" aria-checked="${s.key === state.shade}" tabindex="${s.key === state.shade ? 0 : -1}" data-key="${s.key}">
        <span class="swatch-tile__img"><img src="${PLP_ASSET(`swatches/${s.key}.png`)}" alt="" width="89" height="120" loading="lazy" decoding="async"></span>
        <span class="swatch-tile__name">${s.name}</span>
      </button>`).join("");
    $("#explore-label").textContent = shadeBy(state.shade).name;
  }

  function renderGallery() {
    if (shown === state.shade) return;
    shown = state.shade;
    const list = photos(shadeBy(state.shade));
    track.innerHTML = list.map((p, i) => `
      <figure class="gallery__slide" aria-roledescription="slide" aria-label="${i + 1} of ${list.length}">
        <img src="${p.src}" alt="${p.alt}" width="700" height="700" ${i ? 'loading="lazy"' : ""}>
        ${i === 0 ? `<button type="button" class="peruse" aria-haspopup="dialog" aria-controls="peruse-sheet"><span class="peruse__v"></span>/use<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2.4"/><path d="M12 10.5v6.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/><circle cx="12" cy="7" r="1.6" fill="currentColor"/></svg></button>` : ""}
      </figure>`).join("");
    updatePerUse();
    dots.innerHTML = list.map(() => "<span></span>").join("");
    thumbs.innerHTML = list.map((p, i) => `
      <button type="button" class="gallery__thumb" data-i="${i}" aria-label="Show photo ${i + 1}"><img src="${p.src}" alt="" loading="lazy"></button>`).join("");
    track.scrollTo({ left: 0, behavior: "instant" });
    sync();
  }

  const index = () => Math.round(track.scrollLeft / track.clientWidth);
  const go = i => track.scrollTo({ left: Math.max(0, Math.min(track.children.length - 1, i)) * track.clientWidth });
  function sync() {
    const i = index(), n = track.children.length;
    [...dots.children].forEach((d, j) => d.classList.toggle("on", j === i));
    [...thumbs.children].forEach((t, j) => t.classList.toggle("on", j === i));
    $("[data-gprev]").disabled = i <= 0;
    $("[data-gnext]").disabled = i >= n - 1;
  }

  function choose(key, focus) {
    state.shade = key;
    renderExplore();
    renderGallery();
    if (focus) $(`#explore [data-key="${key}"]`).focus();
  }

  $("#explore").addEventListener("click", e => { const b = e.target.closest(".swatch-tile"); if (b) choose(b.dataset.key); });
  $("#explore").addEventListener("keydown", e => {
    const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!d) return;
    e.preventDefault();
    const i = SHADES.findIndex(s => s.key === state.shade);
    choose(SHADES[(i + d + SHADES.length) % SHADES.length].key, true);
  });
  $("[data-gprev]").addEventListener("click", () => go(index() - 1));
  $("[data-gnext]").addEventListener("click", () => go(index() + 1));
  thumbs.addEventListener("click", e => { const b = e.target.closest(".gallery__thumb"); if (b) go(+b.dataset.i); });
  track.addEventListener("scroll", sync, { passive: true });
  track.addEventListener("keydown", e => { if (e.key === "ArrowRight") { e.preventDefault(); go(index() + 1); } if (e.key === "ArrowLeft") { e.preventDefault(); go(index() - 1); } });

  // ---- Cost-per-use tag on the first photo + bottom-sheet explainer ---------
  const { money, perUse, approx, BUNDLES } = window.Polar;
  const sheet = document.createElement("div");
  sheet.className = "sheet"; sheet.id = "peruse-sheet"; sheet.hidden = true;
  sheet.setAttribute("role", "dialog"); sheet.setAttribute("aria-modal", "true"); sheet.setAttribute("aria-labelledby", "peruse-title");
  sheet.innerHTML = `
    <div class="sheet__panel">
      <span class="sheet__grab" aria-hidden="true"></span>
      <button type="button" class="sheet__close" aria-label="Close">✕</button>
      <h2 id="peruse-title"><span class="peruse__v"></span> per application</h2>
      <p>Up to 15 applications per 200 ml bottle.</p>
      <p>Each application lasts 6 to 8 weeks, keeping grays hidden longer.</p>
      <table class="sheet__table">
        <thead><tr><th scope="col"><span class="sr-only">Compare</span></th><th scope="col">Polar Haircare</th><th scope="col">Box dye</th></tr></thead>
        <tbody>
          <tr><th scope="row">Cost per use</th><td class="yes-cell"><span class="peruse__v"></span></td><td>${approx(PAGE.boxDyeUsd || 15)}</td></tr>
          <tr><th scope="row">Number of uses</th><td class="yes-cell">15 applications</td><td>1 application</td></tr>
        </tbody>
      </table>
    </div>`;
  document.body.appendChild(sheet);
  let lastFocus = null;
  const openSheet = () => { lastFocus = document.activeElement; sheet.hidden = false; document.body.classList.add("no-scroll"); sheet.querySelector(".sheet__close").focus(); };
  const closeSheet = () => { sheet.hidden = true; document.body.classList.remove("no-scroll"); if (lastFocus) lastFocus.focus(); };
  sheet.addEventListener("click", e => { if (e.target === sheet || e.target.closest(".sheet__close")) closeSheet(); });
  document.addEventListener("keydown", e => { if (!sheet.hidden && e.key === "Escape") closeSheet(); });
  track.addEventListener("click", e => { if (e.target.closest(".peruse")) openSheet(); });
  function updatePerUse() {
    const v = money(perUse(state.bundle));
    document.querySelectorAll(".peruse__v").forEach(el => { el.textContent = v; });
    const btn = track.querySelector(".peruse");
    if (btn) btn.setAttribute("aria-label", `${v} per use with ${BUNDLES[state.bundle].name.toLowerCase()}. Show cost details.`);
  }

  // The shade finder and quantity tiles change state through app.js; follow them here
  document.addEventListener("polar:change", () => { renderExplore(); renderGallery(); updatePerUse(); });

  renderExplore();
  renderGallery();
})();

/* buybox.js */
// Variation B buy box: quantity tiles + "Early Black Friday Sale Exclusive" rewards panel.
// Uses the shared bundle state, so the shade picker and these tiles stay in sync.
(() => {
  const { state, BUNDLES, money, setBundle } = window.Polar;
  const $ = s => document.querySelector(s);
  const BADGES = ["", "+ FREE SHIPPING", "+ FREE CONDITIONER"];
  const EACH = BUNDLES.map(o => o.price / o.qty);

  function render() {
    const cur = state.bundle, n = BUNDLES[cur].qty;
    $("#qty").innerHTML = BUNDLES.map((o, i) => `
      <button type="button" class="qty__tile" role="radio" aria-checked="${i === cur}" tabindex="${i === cur ? 0 : -1}" data-i="${i}">
        ${BADGES[i] ? `<span class="qty__badge qty__badge--${i}">${BADGES[i]}</span>` : ""}
        <span class="qty__box">${o.name}</span>
        <span class="qty__each">${money(EACH[i])} each</span>
      </button>`).join("");

    const unlocked = (n >= 2) + (n >= 3);
    $("#unlock-count").textContent = `${unlocked} of 2 unlocked`;
    $("#unlock-fill").style.width = `${[8, 50, 100][cur]}%`;
    document.querySelectorAll(".unlock__card").forEach(c => c.classList.toggle("on", n >= +c.dataset.at));
    $("#unlock-msg").innerHTML = [
      "Add <strong>1 more bottle</strong> to unlock free shipping",
      "Add <strong>1 more bottle</strong> to unlock your free conditioner",
      "Free shipping and free conditioner unlocked!",
    ][cur];
    $("#unlock-msg").classList.toggle("done", cur === 2);
  }

  $("#qty").addEventListener("click", e => { const b = e.target.closest(".qty__tile"); if (b) setBundle(+b.dataset.i); });
  $("#qty").addEventListener("keydown", e => {
    const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!d) return;
    e.preventDefault();
    setBundle((state.bundle + d + 3) % 3);
    $(`#qty [data-i="${state.bundle}"]`).focus();
  });
  document.addEventListener("polar:change", render);
  render();
})();

// Customer video testimonials (same videos as the product page, hosted on Polar's Shopify CDN).
// Videos load only when tapped, and only one plays at a time.
(() => {
  const CDN = "https://polarhaircare.com/cdn/shop";
  const VIDS = [
    ["ce19c31e9a8141d89591645d060f9f53", "HD-1080p-7.2Mbps-86089810"],
    ["d1a273ffb15e4aa68168c790226bd003", "HD-1080p-7.2Mbps-86089811"],
    ["7487b0aac72740cb90217996474f9c42", "HD-1080p-7.2Mbps-86089808"],
    ["594914a919f144e9b5be869a996e6530", "HD-1080p-7.2Mbps-80154973"],
    ["31ada0f9ea914f1d84a0eb78b6cc512a", "HD-1080p-4.8Mbps-58143856"],
    ["e3e9002a89874674a686962605cf4c78", "HD-1080p-4.8Mbps-58143855"],
    ["56ba46fa58e04fc7a6def0f343369244", "HD-1080p-7.2Mbps-86089805"],
    ["0912af752ba84a7abde021dfb137bbaf", "HD-1080p-7.2Mbps-86089807"],
    ["3ed16314be7f47788e2de7244f4ad1af", "HD-1080p-7.2Mbps-86089809"],
    ["3a779b0a4f6243fb897db8f9225b2737", "HD-1080p-7.2Mbps-86089806"],
    ["8fea7c0f24cf4d22b60069a548023b07", "HD-1080p-4.8Mbps-35778129"],
    ["9edb026fc0e54cfe9d8e3cec264631fe", "HD-720p-1.6Mbps-45989993"],
  ];
  const track = document.getElementById("tvids-track");
  if (!track) return;
  // A page can bring its own videos: window.POLAR_PAGE.tvids = [{ src, poster }]
  const LIST = window.Polar.PAGE.tvids || VIDS.map(([id, r]) => ({
    src: `${CDN}/videos/c/vp/${id}/${id}.${r}.mp4`,
    poster: `${CDN}/files/preview_images/${id}.thumbnail.0000000000_400x.jpg`,
  }));
  track.innerHTML = LIST.map(({ src, poster }, i) => `
    <div class="tvid">
      <video preload="none" playsinline data-poster="${poster}" aria-label="Customer video review ${i + 1} of ${LIST.length}">
        <source src="${src}" type="video/mp4">
      </video>
      <button type="button" class="tvid__play" aria-label="Play customer video ${i + 1}"><span aria-hidden="true"></span></button>
    </div>`).join("");

  const all = [...track.querySelectorAll("video")];
  // Thumbnails load only when the carousel comes near the screen
  const showPosters = () => all.forEach(v => { if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } });
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { showPosters(); io.disconnect(); } }, { rootMargin: "600px 0px" });
    io.observe(track);
  } else showPosters();
  track.addEventListener("click", e => {
    const card = e.target.closest(".tvid"); if (!card) return;
    const v = card.querySelector("video");
    if (v.paused) {
      all.forEach(o => { if (o !== v) { o.pause(); o.closest(".tvid").classList.remove("playing"); } });
      v.controls = true; v.play().catch(() => {}); card.classList.add("playing");
    }
  });
  all.forEach(v => {
    v.addEventListener("pause", () => v.closest(".tvid").classList.remove("playing"));
    v.addEventListener("play", () => v.closest(".tvid").classList.add("playing"));
  });
  const step = () => track.firstElementChild.getBoundingClientRect().width + 12;
  document.querySelector("[data-tprev]").addEventListener("click", () => track.scrollBy({ left: -step() }));
  document.querySelector("[data-tnext]").addEventListener("click", () => track.scrollBy({ left: step() }));
})();

// "Selling out fast": shown with a stock figure and a running countdown (app.js settings).
(() => {
  const { saleLeft, STOCK_SOLD_PCT } = window.Polar;
  const box = document.getElementById("stock");
  if (!box || STOCK_SOLD_PCT == null || !(saleLeft() > 0)) return;
  const pct = Math.max(0, Math.min(100, Math.round(STOCK_SOLD_PCT)));
  document.getElementById("stock-fill").style.width = pct + "%";
  document.getElementById("stock-pct").textContent = `${pct}% sold`;
  const out = document.getElementById("stock-timer"), pad = n => String(n).padStart(2, "0");
  const tick = () => {
    const left = saleLeft();
    if (left <= 0) { box.hidden = true; clearInterval(t); return; }
    out.textContent = `${pad(Math.floor(left / 36e5))}:${pad(Math.floor(left / 6e4) % 60)}:${pad(Math.floor(left / 1e3) % 60)}`;
  };
  box.hidden = false; tick();
  const t = setInterval(tick, 1000);
})();

// Fill every marked price with the visitor's market price (Shopify) or the USD offer (local preview)
(() => {
  const P = window.Polar, B = P.BUNDLES, all = s => document.querySelectorAll(s);
  all("[data-maxsave]").forEach(e => { e.textContent = P.MAX_SAVE; });
  all("[data-save1]").forEach(e => { e.textContent = Math.round((1 - B[0].price / B[0].compare) * 100); });
  all("[data-approx]").forEach(e => { e.textContent = P.approx(+e.dataset.approx); });
  all("[data-peruse]").forEach(e => { e.textContent = P.money(P.perUse(+e.dataset.peruse)); });
  all("[data-gift]").forEach(e => { e.textContent = P.money(P.GIFT_VALUE); });
  all("[data-bundle]").forEach(e => { e.textContent = P.money(B[+e.dataset.bundle].price); });
  all("[data-ship]").forEach(e => { e.textContent = P.SHIP_1 == null ? (e.dataset.shipAlt ?? "") : P.money(P.SHIP_1); });
  if (P.SHIP_1 == null) all("[data-ship-hide]").forEach(e => e.remove());
})();

/* picker.js */
// Variation B shade picker: choose bundle -> "Select your shade" -> pick shades and quantities -> checkout.
// Pricing follows the total number of bottles picked (1, 2 or 3), so adding a bottle upgrades the deal.
(() => {
  const { state, SHADES, BUNDLES, STORE, CONDITIONER_ID, money, shadeBy, setBundle, SHIP_1, GIFT_VALUE, shadeImg } = window.Polar;
  const MAX = 3;
  const SHIP = SHIP_1 || 0; // null = shipping for this market is shown at checkout
  const $ = s => document.querySelector(s);
  const counts = Object.fromEntries(SHADES.map(s => [s.key, 0]));
  const open = new Set(); // expanded shade cards
  let lastRewards = 0, lastFocus = null, want = 3; // want = bundle size chosen before opening

  const total = () => Object.values(counts).reduce((a, b) => a + b, 0);
  const tierFor = n => BUNDLES[Math.max(1, Math.min(n, MAX)) - 1];
  const rewardsFor = n => (n >= 1) + (n >= 2) + (n >= 3);

  // ---- Main page button reflects the chosen bundle -------------------------
  function updateCta() {
    const o = BUNDLES[state.bundle];
    $("#cta-compare").textContent = money(o.compare);
    $("#cta-price").textContent = money(o.price);
  }
  document.addEventListener("polar:change", updateCta);

  // ---- Render --------------------------------------------------------------
  function card(s) {
    const n = counts[s.key], full = total() >= MAX, isOpen = open.has(s.key);
    return `
      <div class="pcard${n ? " is-on" : ""}" data-key="${s.key}">
        <div class="pcard__row">
          <img class="pcard__img" src="${PLP_ASSET(`bottle-${s.key}.jpg`)}" alt="" width="84" height="84">
          <p class="pcard__name">${s.name}</p>
          <div class="stepper" role="group" aria-label="${s.name} quantity">
            <button type="button" data-act="minus" aria-label="Remove one ${s.name}" ${n ? "" : "disabled"}>−</button>
            <output aria-live="polite">${n}</output>
            <button type="button" data-act="plus" aria-label="Add one ${s.name}" ${full ? "disabled" : ""}>+</button>
          </div>
          <button type="button" class="pcard__more" data-act="more" aria-expanded="${isOpen}" aria-label="${isOpen ? "Hide" : "Show"} ${s.name} photos"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" style="transform:rotate(${isOpen ? 180 : 0}deg)"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
        </div>
        ${isOpen ? `
        <div class="pcard__detail">
          <figure><img src="${PLP_ASSET(`bottle-${s.key}.jpg`)}" alt="${s.name} bottle" loading="lazy"><figcaption>Product</figcaption></figure>
          <figure><img src="${(window.Polar.PAGE.toneImg || (k => PLP_ASSET(`tones/${k}.jpg`)))(s.key)}" alt="${s.name} hair tone" loading="lazy"><figcaption>Hair tone</figcaption></figure>
          <figure><img src="${shadeImg(s.key)}" alt="${s.name} before and after" loading="lazy"><figcaption>${s.key === "purple" ? "Result" : "Before and after"}</figcaption></figure>
        </div>` : ""}
      </div>`;
  }

  function render() {
    const n = total(), o = tierFor(n || want);
    $("#picker-title").textContent = n >= MAX ? "Your 3 bottles are ready" : `Pick ${want === 1 ? "your shade" : `your ${Math.max(want, n)} shades`}`;
    $("#picker-sub").innerHTML = {
      1: `EARLY BLACK FRIDAY SALE: 1 bottle for <strong>${money(BUNDLES[0].price)}</strong> (${SHIP_1 == null ? "+ shipping" : `+ ${money(SHIP_1)} shipping`}). Add 1 more for free shipping.`,
      2: `EARLY BLACK FRIDAY SALE: 2 bottles for <strong>${money(BUNDLES[1].price)}</strong> with free shipping. Add 1 more for a free conditioner.`,
      3: `EARLY BLACK FRIDAY SALE: your 3 bottles at <strong>${money(BUNDLES[2].price / 3)} each</strong>, free shipping and a free Color Protect Conditioner included.`,
    }[o.qty];

    $("#picker-list").innerHTML = SHADES.map(card).join("");

    // Rewards track
    $("#rewards-fill").style.width = `${n <= 1 ? 0 : (n - 1) * 50}%`;
    document.querySelectorAll("#rewards-steps li").forEach(li => li.classList.toggle("on", n >= +li.dataset.at));

    // Summary
    const lines = SHADES.filter(s => counts[s.key]).map(s => `<p class="sum__row"><span>${s.name} × ${counts[s.key]}</span></p>`).join("");
    if (!n) {
      $("#summary-lines").innerHTML = `<p class="sum__empty">No shades picked yet. Tap + to add a bottle.</p>`;
    } else {
      const ship = n >= 2 ? `${SHIP ? `<s>${money(SHIP)}</s> ` : ""}<b class="free">FREE</b>` : (SHIP_1 == null ? "Calculated at checkout" : money(SHIP));
      const pay = o.price + (n >= 2 ? 0 : SHIP);
      $("#summary-lines").innerHTML = `${lines}
        <p class="sum__row"><span>${o.name} (${o.save})</span><span><s>${money(o.compare)}</s> ${money(o.price)}</span></p>
        <p class="sum__row"><span>Shipping</span><span>${ship}</span></p>
        ${n >= 3 ? `<p class="sum__row"><span>Color Protect Conditioner</span><span><s>${money(GIFT_VALUE)}</s> <b class="free">FREE</b></span></p>` : ""}
        <p class="sum__row sum__total"><span>${n < 2 && SHIP_1 == null ? "Subtotal" : "Total"}</span><span>${money(pay)}</span></p>`;
    }

    // Footer
    const saving = n ? o.compare - o.price + (n >= 3 ? GIFT_VALUE : 0) + (n >= 2 ? SHIP : 0) : 0;
    $("#picker-saving").textContent = n ? `You’re saving ${money(saving)}` : "Pick a shade to start";
    $("#picker-gifts").textContent = `REWARDS: ${rewardsFor(n)}/3`;
    $("#picker-gifts").classList.toggle("all", n >= 3);
    const btn = $("#picker-checkout");
    btn.setAttribute("aria-disabled", String(!n));
    btn.href = n ? checkoutUrl() : "#";
    $("#picker-hint").textContent = !n ? "" : n < want
      ? `Add ${want - n} more to get your ${want}-bottle deal.`
      : n < MAX ? `Add 1 more to unlock ${n === 1 ? "free shipping" : "a free conditioner"}.` : "All rewards unlocked!";

    // Celebrate newly unlocked rewards
    const r = rewardsFor(n);
    if (r > lastRewards && n > 0) toast(["", "Early Black Friday Sale price unlocked!", "🚚 Free shipping unlocked!", "🎁 Free conditioner unlocked!"][r]);
    lastRewards = r;
  }

  function toast(msg) {
    const t = $("#picker-toast");
    t.textContent = msg;
    t.classList.remove("show"); void t.offsetWidth; t.classList.add("show");
  }

  // Shopify cart permalink for mixed shades at the tier price; + free conditioner at 3
  function checkoutUrl() {
    const n = total(), tier = Math.min(n, MAX) - 1;
    const lines = SHADES.filter(s => counts[s.key]).map(s => `${s.ids[tier]}:${counts[s.key]}`);
    if (n >= 3) lines.push(`${CONDITIONER_ID}:1`);
    const url = new URL(`${STORE}/cart/${lines.join(",")}`, location.origin);
    new URLSearchParams(location.search).forEach((v, k) => { if (/^utm_|^fbclid$/.test(k)) url.searchParams.set(k, v); });
    return url.toString();
  }

  // ---- Events --------------------------------------------------------------
  $("#picker-list").addEventListener("click", e => {
    const b = e.target.closest("button"); if (!b || b.disabled) return;
    const key = b.closest(".pcard").dataset.key, act = b.dataset.act;
    if (act === "plus" && total() < MAX) counts[key]++;
    if (act === "minus" && counts[key] > 0) counts[key]--;
    if (act === "more") open.has(key) ? open.delete(key) : open.add(key);
    // Picking more than the chosen bundle upgrades it (and the main-page selection)
    if (act === "plus" && total() > want) { want = total(); setBundle(want - 1); }
    render();
    const again = document.querySelector(`.pcard[data-key="${key}"] [data-act="${act}"]`);
    (again && !again.disabled ? again : document.querySelector(`.pcard[data-key="${key}"] [data-act="more"]`)).focus();
  });

  $("#picker-checkout").addEventListener("click", e => { if (!total()) e.preventDefault(); });

  let pickedFor = null; // buy-box shade + quantity the current picks were made for (PAGE.prefillPicker)
  function show() {
    lastFocus = document.activeElement;
    // If the buy-box shade or quantity changed since last time, start again from the new choice
    if (window.Polar.PAGE.prefillPicker && pickedFor && (pickedFor.bundle !== state.bundle || pickedFor.shade !== state.shade)) {
      Object.keys(counts).forEach(k => { counts[k] = 0; });
    }
    want = Math.max(BUNDLES[state.bundle].qty, total());
    // Start with the shade-finder pick (if any) filled in for the chosen bundle
    // (pages with PAGE.prefillPicker also start with the shade + quantity chosen in the buy box)
    if (!total() && (state.fromFinder || window.Polar.PAGE.prefillPicker)) counts[state.shade] = BUNDLES[state.bundle].qty;
    if (!total()) open.add(state.shade);
    lastRewards = rewardsFor(total());
    render();
    $("#picker").hidden = false;
    document.body.classList.add("no-scroll");
    $("#picker-back").focus();
  }
  function hide() {
    pickedFor = { bundle: state.bundle, shade: state.shade };
    $("#picker").hidden = true;
    document.body.classList.remove("no-scroll");
    if (lastFocus) lastFocus.focus();
  }
  $("#select-shade").addEventListener("click", show);
  $("#picker-back").addEventListener("click", hide);
  $("#picker").addEventListener("click", e => { if (e.target.id === "picker") hide(); });
  document.addEventListener("keydown", e => {
    if ($("#picker").hidden) return;
    if (e.key === "Escape") hide();
    if (e.key === "Tab") { // keep focus inside the dialog
      const f = [...$("#picker").querySelectorAll("button:not([disabled]), a[href]")];
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  updateCta();
})();

// Estimated delivery under "You're saving": today + 6 to 8 days, shown to every visitor (Polar's choice).
(() => {
  const el = document.getElementById("picker-eta"); if (!el) return;
  const [from, to] = [6, 8];
  const ord = d => d + (d % 10 === 1 && d !== 11 ? "st" : d % 10 === 2 && d !== 12 ? "nd" : d % 10 === 3 && d !== 13 ? "rd" : "th");
  const fmt = n => { const d = new Date(); d.setDate(d.getDate() + n); return `${d.toLocaleDateString("en-US", { month: "short" })} ${ord(d.getDate())}`; };
  document.getElementById("picker-eta-text").innerHTML = `Get it between <strong>${fmt(from)}</strong> and <strong>${fmt(to)}</strong>.`;
  // Pages can show the visitor's country flag instead of the truck (PAGE.etaFlag). Country comes from
  // Shopify (window.PLP_PRICING.country, set in the layout); the local preview falls back to the US.
  if (window.Polar.PAGE.etaFlag) {
    const cc = String((window.PLP_PRICING && window.PLP_PRICING.country) || "US").toUpperCase();
    const icon = el.querySelector("svg");
    if (/^[A-Z]{2}$/.test(cc) && icon) {
      const flag = document.createElement("span");
      flag.className = "picker__flag"; flag.setAttribute("aria-hidden", "true");
      flag.textContent = String.fromCodePoint(...[...cc].map(c => 0x1F1E6 + c.charCodeAt(0) - 65));
      icon.replaceWith(flag);
    }
  }
  el.hidden = false;
})();

/* page */
(() => {
// Review + hair-type carousels: arrows, dots, keyboard
document.querySelectorAll("[data-carousel]").forEach(c => {
  const track = c.querySelector(".carousel__track"), slides = [...track.children];
  const prev = c.querySelector("[data-prev]"), next = c.querySelector("[data-next]"), dots = c.querySelector(".carousel__dots");
  // Scroll positions where each slide snaps to the center. When several slides fit on screen the
  // first and last ones share a position (scroll is clamped), so only the distinct stops are kept.
  const stops = () => {
    const max = track.scrollWidth - track.clientWidth, out = [];
    slides.forEach(sl => {
      const x = Math.round(Math.max(0, Math.min(max, sl.offsetLeft - track.offsetLeft - (track.clientWidth - sl.offsetWidth) / 2)));
      if (!out.length || x - out[out.length - 1] > 2) out.push(x);
    });
    return out;
  };
  const nearest = (s, x) => s.reduce((b, v, i) => (Math.abs(v - x) < Math.abs(s[b] - x) ? i : b), 0);
  // Where an arrow-started scroll is heading, so quick repeated clicks each move one stop
  // (cleared once it arrives, when the visitor swipes, or after a second as a fallback)
  let target = null, timer;
  const update = () => {
    const s = stops();
    if (dots.children.length !== s.length) dots.replaceChildren(...s.map(() => document.createElement("span")));
    const i = nearest(s, target ?? track.scrollLeft);
    [...dots.children].forEach((d, j) => d.classList.toggle("on", j === i));
    prev.disabled = i === 0;
    next.disabled = i === s.length - 1;
  };
  const go = dir => {
    const s = stops(), i = Math.max(0, Math.min(s.length - 1, nearest(s, target ?? track.scrollLeft) + dir));
    target = s[i];
    clearTimeout(timer);
    timer = setTimeout(settle, 1000);
    track.scrollTo({ left: target });
    update();
  };
  prev.onclick = () => go(-1);
  next.onclick = () => go(1);
  const settle = () => { target = null; update(); };
  track.addEventListener("scroll", () => { if (target !== null && Math.abs(track.scrollLeft - target) < 2) target = null; update(); }, { passive: true });
  track.addEventListener("scrollend", settle);
  ["pointerdown", "wheel", "touchstart"].forEach(t => track.addEventListener(t, settle, { passive: true }));
  track.addEventListener("keydown", e => { if (e.key === "ArrowRight") { e.preventDefault(); next.click(); } if (e.key === "ArrowLeft") { e.preventDefault(); prev.click(); } });
  addEventListener("resize", update);
  update();
});
// "Now there's an easier way" video: play only while on screen; the label follows the steps
(() => {
  const v = document.getElementById("steps-video"); if (!v) return;
  const chip = document.getElementById("steps-chip");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) { v.removeAttribute("autoplay"); v.pause(); v.controls = true; }
  new IntersectionObserver(([e]) => { if (reduce) return; e.isIntersecting ? v.play().catch(() => {}) : v.pause(); }, { threshold: .4 }).observe(v);
  const update = () => {
    const t = v.currentTime;
    chip.textContent = t < 1.7 ? "Before: gray" : t < 3.4 ? "Step 1: lather into dry hair" : t < 5.3 ? "10 minutes later: rinse" : "Before & after";
    chip.classList.toggle("chip--after", t >= 5.3);
  };
  v.addEventListener("timeupdate", update);
  update();
})();
// Muted videos (pump, beard): play while on screen, pause when out
const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
document.querySelectorAll(".pump__media video, .beard__video video, .love__video video, .type-card video").forEach(v => {
  if (reduceMotion) { v.controls = true; return; }
  new IntersectionObserver(([e]) => e.isIntersecting ? v.play().catch(() => {}) : v.pause(), { threshold: .4 }).observe(v);
});
// Hero video: label follows the story (before → after); pause for reduced-motion users
(() => {
  const v = document.querySelector(".hero__video"), chip = document.getElementById("vid-chip");
  if (!v) return;
  if (reduceMotion) { v.controls = true; }
  else {
    // Start only after load, so the poster image (not the video) is the first paint
    const start = () => { v.preload = "auto"; v.play().catch(() => {}); };
    document.readyState === "complete" ? start() : window.addEventListener("load", start, { once: true });
  }
  v.addEventListener("timeupdate", () => {
    const after = v.currentTime > 4.3;
    chip.textContent = after ? "After" : v.currentTime > 1.9 ? "Lather, wait, rinse" : "Before: gray";
    chip.classList.toggle("chip--after", after);
  });
})();

})();